
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ واضح`,
'deleteKey': `⌦ حذف`,
'downKey': `↓ لأسفل`,
'endKey': `⤓ النهاية`,
'enterKey': `أدخل`,
'escapeKey': `⎋ الهروب`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`إنشاء 
          <code>ترخيص
          </code> ملف
        `,
'homeKey': `⤒ الصفحة الرئيسية`,
'keyCommand': `⌘ الأمر/الفوز`,
'keyControl': `^ التحكم`,
'keyOption': `خيار/خيار`,
'keyShift': `⇧ التحول`,
'leftKey': `← اليسار`,
'pagedownKey': `▼ ترحيل`,
'pageupKey': `▲صفحة المتابعة`,
'rightKey': `→ اليمين`,
's00065e45db8c0441': `راجع أدوات المطورين لمزيد من التفاصيل`,
's001dd78415a91fa0': `مزراب شريط التمرير`,
's002fa7d1054ed082': `مربع الحدود`,
's006f872a5b7f5279': `سانجرو`,
's01b16a926920908b': `الكازاخستانية`,
's01b56d233c6c5cac': `التقسيم`,
's01d32b35baa3b676': `المؤلف`,
's02106cc2ef0e7578': `دبوس جديد...`,
's02ab1ea8e5100fc1': `وضع علامة على التحديد على أنه "تجاوز ثنائي الاتجاه`,
's0312976fe9da5951': `الزر`,
's03608a32f05eded2': `قرصة التكبير/التصغير`,
's036d35e03be98d22': `عمق الرياضيات`,
's037b1dc850a89273': `بديل تحت`,
's0396202b716732ec': `ضع علامة على التحديد على أنه تم ضربه من خلال`,
's03f49e598ffb11cc': `البولندية`,
's0448f1059fa01720': `حفظ أو مشاركة أو طباعة المستكشف الخاص بك. قم بتحرير معلومات مثل العنوان أو اللغة أو الترخيص.`,
's0458872c43beadef': `إدراج صف قبل`,
's04c939a414fdab21': `تسونغا`,
's050954cd4ae83304': `التباعد بين الكلمات`,
's05e9759cfd99c48f': `تبرير`,
's063fa5a0a4903bf4': `جانبياً، من اليسار إلى اليمين`,
's064339c229374050': `الترميز`,
's06634274f19b0572': `اختيار الدبوس`,
's06743b24499f0035': `مركز الارتكاز`,
's07808b0ca6da8fef': `الموقع الإلكتروني المسيّج`,
's07970793b21351fd': `حاوية روبي الأساسية`,
's079cf7850d9327f0': `الخط`,
's07aa10850d9ddcc7': `الاستمارة`,
's07e6118e838b2e23': `الملاحة`,
's0816468df86e4036': `فتح الإعدادات`,
's082869038c117fe5': `البرتغالية (البرازيل)`,
's086e6c267ade2609': `التشبع`,
's08e12ade32ef8125': `سيتسوانا`,
's08e6bd98452e6bb9': `الصوت`,
's0978fb5ba3145996': `إدراج قائمة (غير مرتبة)`,
's09c3f1d21de14ae1': `ضع علامة على التحديد كخط تحته خط`,
's0a2d91c6720033e9': `تقليم مسافات النص`,
's0a3ddcba94027d95': `تناسب الكائن`,
's0a6cb8d42cdb0c4a': `الإسبرانتو`,
's0a799f583098cadf': `إدراج تنقل`,
's0a7db790db1fc45c': `وضع علامة على التحديد كامتداد`,
's0b1271f50a77dc73': `مربع المحتوى`,
's0b24d08ea349b455': `كل شيء يمكنك إدراجه. في البداية توجد عناصر غير تفاعلية مثل القوائم أو الصور، ثم تأتي العناصر التفاعلية التي تسمى عناصر واجهة المستخدم. يمكنك الحصول على عناصر جديدة بالنقر على شريط البحث.`,
's0b7ae9543c001867': `الرد`,
's0bdca49248ba4820': `الاختصارات`,
's0befccf152b6c0a9': `التوجيه من البيانات الوصفية`,
's0c11e479416c8421': `إدراج تعليق توضيحي للجدول`,
's0c27336067c59611': `حشوة التمرير`,
's0c4593d81f147042': `خط الأساس`,
's0c4b2e98d4ab7f5a': `أوامر التطبيق`,
's0c883713b83616a8': `حفظ المستند النشط`,
's0ca5c0460199cba1': `الاختصار`,
's0cf10c4f40588f8d': `شرح الجدول`,
's0d86afa3c6a1e28b': `الاتجاه المرن`,
's0dad143dff0079fc': `المالايالامية`,
's0db05bd7ba6fff96': `مستندك القابل للاستكشاف. يمكنك كتابة النص ونسخه/لصقه وتحريره وما إلى ذلك هنا.`,
's0dc07f97c821463c': `اختيار التعليق`,
's0dc452999c129e15': `تمكين إعادة التحميل المباشر`,
's0de0febab8a4beaf': `خطأ في قراءة هذه الحزمة`,
's0e44968489e076a8': `صيني`,
's0e4862e87c7d53ce': `وضع علامة على التحديد كاقتباس`,
's0e6ea8870dbddab2': `أوامر المستند`,
's0ee28503778e4c0c': `خط الأساس الأخير`,
's0ef01c03299bbb83': `الديكور`,
's0f17f32919661cff': `المنغولية`,
's0f350bc4e538e3ea': `الكلمات`,
's105540b7756c0232': `مصطلح التعريف`,
's105a06836c40fcb4': `تعيين الفلاتر والألوان ومزج العناصر المحددة`,
's106b274b5af798e5': `الجُمل`,
's1082e1649793dca9': `وضع علامة على التحديد كمصطلح محدد`,
's10f3845975a0351e': `تحرير البيانات الوصفية`,
's1125d159f7e64df5': `العرض`,
's11326fd2590f4e5e': `افتراضي`,
's1155ec07a221e739': `شريط التمرير`,
's1173bf7a3e0b74c9': `الحد الأدنى (ذ)`,
's1177237a3e0e548c': `الحد الأدنى (س)`,
's1219d97b49650c05': `الرؤية`,
's123bea44f38abccf': `إدراج كائن`,
's1245e2cb9f20197e': `محاذاة`,
's12946ec1b850962c': `إدراج عمود بعد`,
's1351209ef74ee729': `امتداد جميع الأعمدة`,
's13c60cb409e8cb6f': `محاذاة المركز`,
's13ebd619c8a06a6d': `صفوف الشبكة التلقائية`,
's13ef8ca26ca8861b': `عنصر القطع`,
's151349210ac1d2d8': `إدراج مجموعة`,
's151bc2eea7a032a4': `-تغيرت-`,
's153bc3c3aa39587b': `رأس الطاولة`,
's156647179b21d351': `إدراج هيئة الجدول`,
's158b6ec6b1fffcb2': `استراحة بعد`,
's15d0c0657c1ee08c': `مفتاح واجهة برمجة التطبيقات`,
's1626a7e10a9f9dcc': `يضبط عائلة خط التحديد`,
's1637c7d1a30629e2': `صندوق الحدود`,
's1641ab440bf4daa4': `تحديث حزمة الأدوات هذه`,
's166bd56d19670a72': `تكبير/تصغير`,
's1696c76a23c0834e': `متقدم: إظهار الحزم التي تحتوي على إصدارات مثل 0.x.x في مدير الحزم`,
's16b9446e3a70e1f4': `السمات`,
's16f205466761e583': `لا يوجد تحجيم بصري للخط`,
's16f2f1c2c516d307': `فتح مستند`,
's1749014f3f87fa6a': `التمدد`,
's17597a8bb4810524': `الترخيص`,
's17bfaaa4e7528bc7': `باشكير`,
's17fb3f4805f4f4b9': `إزالة الحقل`,
's181ef198cf83ec3a': `بيهاري`,
's1857db526dc4dcdd': `إنشاء الحزمة`,
's18d5c44aae3dc82a': `عبر الإنترنت عند التحرير`,
's1988d71ef8060edf': `إدراج صف جدول`,
's19abee1277c9bca2': `ساموا`,
's19daf2f26c19543d': `المخطط التفصيلي`,
's1a1acc902e6668e0': `إظهار تنسيق النص المتقدم`,
's1a5230a71d9285c1': `الالتقاط`,
's1aa1cb63ad44bc6f': `فجوة العمود`,
's1af8b67d1c85c811': `المسافة بين`,
's1b4a36fce2456660': `عائلة الخط`,
's1c246045629b0016': `وضع علامة على التحديد كحذف`,
's1c3fc313a9184670': `الرابط العام`,
's1c65f5004a07dcfa': `الغيلية الاسكتلندية`,
's1c690963f1e2df00': `مظهر خاص بالمنصة`,
's1ca22ce85e074da5': `براغما`,
's1d10d2058d8ca8dd': `هل تريد جولة قصيرة بصحبة مرشد سياحي؟`,
's1d19244f549ec535': `التعليم`,
's1d5c7b28e8b50d6d': `درجة الزمالة`,
's1db591f5a54dbfd3': `صندوق المحتوى`,
's1dbb9f50e16c92a3': `نصف قطر الحدود`,
's1dfb744260fb3a01': `عزل ثنائي الاتجاه`,
's1e9c2c654732cc5f': `البيلاروسية`,
's1eaccbf2d6af8ab5': `المعلومات`,
's1efbfc3937d565bd': `الخلفية`,
's1f2b49c1bca2035d': `الكاتالونية`,
's1f74bdf32b51a5fc': `صورة الخلفية`,
's1f7698c061c208c9': `مفتوح`,
's1f8e59d0624842ff': `الكانادا`,
's1feab14d837eadb0': `غواراني`,
's20deffeecf2699fb': `الكورسيكية`,
's21d61916eb8d137d': `هيئة الجدول`,
's21d723a1dbcd89c8': `الجاوية`,
's21f8a2eaf5a70749': `إدراج تسمية`,
's2206c42e5b835e6e': `ضع علامة على التحديد كاختصار`,
's22a2348c46a912a0': `إدراج قسم`,
's233ae776268cd44b': `الأعمال التجارية`,
's236ed7ba747099b0': `وزن الخط`,
's2474e7fb1aec9f05': `الاختبار`,
's2492f5fb1b05b45e': `النص`,
's24949d7adbb5a098': `صندوق الأدوات`,
's252a52330d32b900': `البيانات الوصفية`,
's2540844a4bc4d9ba': `تتطلب الإسناد؟`,
's255857544a9d5ec0': `إعادة تعيين`,
's255c77900f2b5e0f': `نظام الألوان`,
's256ab831a48c941c': `يزيل جميع تنسيقات النص من التحديد`,
's2591806d7b222591': `إعادة تعيين التغييرات`,
's25e1a07e454c2c11': `الشبكة`,
's262abbaf1d05f009': `ضوء خافت`,
's266935f2447fcd98': `على اليسار`,
's268ecd1cef45a9a8': `هل أنت متأكد؟`,
's2692bc028fed91f1': `⇪ قفل القبعات`,
's27056379e0acfdb0': `تفتيح`,
's27076e66c5d483ba': `محاذاة رأسية`,
's2712dc5641a33226': `حسابات سجلات الحزمة مخصصة للمطورين وتسمح لك بتكوين سجل واحد أو أكثر`,
's2739460e44320108': `الصينية (التقليدية)`,
's27cc88818cc46ff6': `مستقر`,
's281d957112b10f12': `تحرير HTML للمستند مباشرة`,
's28b6246ce616a548': `إدراج مجموعة أعمدة الجدول`,
's29a1c26521879b9f': `تصغير الحجم`,
's29acfd2778e8c377': `إخفاء تنسيق النص المتقدم`,
's29b24c06315e9343': `إدراج مدخلات`,
's29eb103449472e3b': `إدراج عنوان (المستوى 3)`,
's29ee7434494a0dfe': `إدراج عنوان (المستوى 2)`,
's29f21c34494d614d': `إدراج عنوان (المستوى 1)`,
's29fbfc3449557f72': `إدراج عنوان (المستوى 6)`,
's29ff743449588131': `إدراج عنوان (المستوى 5)`,
's2a031834495bcdb4': `إدراج عنوان (المستوى 4)`,
's2a75c946ef4dcab7': `متفرقات`,
's2b2ae20d26f78ac2': `المربع`,
's2b8f50c64be440f7': str`اختر 
          ${0}...
        `,
's2ba5f4d8f3bd7c57': `الطلب`,
's2bad2d24def4aa0b': `فاصل الأسطر (لغة CJK.)`,
's2ceb11be2290bb1b': `إلغاء`,
's2ced8e8fafb499f6': `حذف العنصر`,
's2d986d31f8d67357': `إدراج مجموعة حقول`,
's2d995a37cf5e4995': `إدراج نوسكربت`,
's2de969afacdaa7a6': `الشكل`,
's2df075aface0dab8': `شارك`,
's2e192b19ed15fcf6': `الصفحة`,
's2e39b99cf23606fa': `تعيين تخطيط العناصر المحددة`,
's2e4818861000b13f': `التصميم`,
's2e66bf8b833858f3': `أويغور`,
's2e969a451b4955d1': `الماراثية`,
's2eda5288a65bca1d': `الفائض (ذ)`,
's2edd6688a65e21f0': `التجاوز (س)`,
's2f0bcdffc92a786b': `تعويم لليمين`,
's2f2044f2431a32d5': `العنوان`,
's2f4d4bfbc466d91f': `الألبانية`,
's2f8da2cb5f236588': `اسم الحزمة الخاصة بك. يجب أن يكون محدد النطاق، على سبيل المثال '@@org/pkg'. `,
's30cce87854901922': `مرحلة ما قبل المدرسة`,
's3124653c272f054c': `لون قاعدة العمود`,
's314a4f7685c8e824': `دائماً`,
's31c06e226322f065': `تجنب الأيتام`,
's323dcde72b850272': `الوصول العام`,
's32911e52ee8ac745': `أدخل فتحة`,
's337a1e9022a8d19f': `الجدول`,
's33c1450d2822bb0f': `إدراج تعليق توضيحي للشكل`,
's33c18d5a4cbffa2a': `الأيرلندية`,
's33f85f24c0f5f008': `الحفظ`,
's342b0cabfa672822': `مساعدة المستخدم في العثور على أداتك`,
's3437e0d9899e7ae1': `إرسال بيانات القياس عن بُعد حول استخدامك لـ WebWriter.`,
's344ea8f4939cdc98': `اللون`,
's34dcda3b0f9d5a98': `تبديل الرابط`,
's34f724979a124c50': `يضبط لون خلفية النص المحدد`,
's355b21b89ce5d9c5': `التفاصيل`,
's35ae5f4e0fa2777b': `محاذاة مخصصة`,
's35aeaff1425bca9e': `لا يدعم WebWriter الوسائط من النوع `,
's35c3125c7750681e': `اقتباس بلوك اقتباس`,
's3643189d1abbb7f4': `الكود`,
's3649bacefe731bf6': `تبديل صندوق الأدوات`,
's365280e16a8ea32d': `نسخ التحديد`,
's366991b9c9287765': `صحيح`,
's36a194e38d653a26': `شرح البيانات`,
's36b3cefdcb897f15': `المنظور`,
's372fae706048ce41': `زوجي فردي`,
's377e24af9628c37e': `قائمة الطلبات`,
's37a8c35f6581da5f': `لا يوجد مرساة`,
's37fa3b9cd51c2dfd': `يضبط حجم خط التحديد`,
's380d17664bb69531': `إدراج عمود قبل`,
's3815184eb09f0dcf': `المؤشر`,
's382a2aa3984474dd': `إنشاء`,
's38980f98cb07ceb8': `حفظ المستند النشط كنسخة`,
's3914cb410fca44d4': `الاستيراد`,
's3a179f6db2972384': `موقع روبي`,
's3a5ca02f282d247e': `شارك...`,
's3ae67088bbefba98': `الحزم`,
's3b0ab4b52326316f': `خفيف`,
's3bc203a3f8a6409c': `تحديث اللغة عبر المستند`,
's3bdad99768e11911': `قابل للاستكشاف`,
's3cb47df8290fa94c': `إدراج خيار`,
's3cf89cb47fdde7e9': `الرابط`,
's3d09398e555ee5f9': `خيارات متقدمة`,
's3d249bb480032121': `القائمة`,
's3d3efd1e19bdcfb4': `شرح التاريخ/الوقت`,
's3d6a732c792ccb9e': `شرح روبي`,
's3d93f9ea0c5a13fa': `الصورة`,
's3d9548e211b958ce': `تخطي التداخلات`,
's3e092e9d1ee2c5bb': `المشبك`,
's3e78ddc9a48a608d': `جميلة`,
's3eb6d1e6e79ed7c4': `لم يتم العثور على أي مستندات`,
's3eca5a034978754b': `حذف التحديد`,
's3f06e9abb6ebcb79': `الشخصيات`,
's3f1e7a3f2b283d3b': `الهامش`,
's3f299e83cbf52fba': `زوانج`,
's3f43ef2eaa1ec486': `الغوجاراتية`,
's3f7e097a9b2e6181': `إدراج مقال`,
's3fd83566dd643d10': `إدراج وسيلة إيضاح`,
's3fe72792941c18f9': `أسفل النص`,
's3ffcdc5db5e7d0c5': `عكسي`,
's40e3826b7f74a3b5': `عموم (يمين)`,
's40f07d7859284a44': `خط الأساس المهيمن`,
's4101ada154a1b958': `الأوسط`,
's410c465a5993f82d': `فرصة كسر الخط`,
's41322d19c928c603': `تكنولوجيا المعلومات والاتصالات`,
's417b90913e05bc17': `معاينة`,
's418f2020fe996832': `تأكيد التغييرات`,
's41c724f0698148e9': `وضع علامة على التحديد كاختصار للوحة المفاتيح`,
's41f65a763f8e44ab': `مجموعة رؤوس الجدول`,
's42721130228841b0': `صندوق السكتة الدماغية`,
's429bd646f1cf8bc6': `تسمح لك حسابات Grammar LLM باستخدام واجهة برمجة تطبيقات Grammar LLM لتصحيح القواعد النحوية في النص.`,
's429dd933ba95549b': `إدراج عنوان`,
's42e470ef1d707a28': `التشغيل التلقائي`,
's42ffdab1291fb3de': `إدراج صف بعد`,
's430831017f3f0499': `الانحراف (ذ)`,
's430bd5017f42511c': `الانحراف (س)`,
's433ba70286202ceb': `كسر الكل`,
's441b20a8a50e36b4': `المقدونية`,
's445b8acb9206db6e': `تجاهل وإلغاء`,
's446a924922651ea0': `التركيز على النص`,
's44cdba92713de38e': `منطقة الشبكة`,
's45518abd911471d0': `الكرواتية`,
's456a8d744313852a': `مساحة حول`,
's4634541f5056a546': `أبخازيا`,
's46d4abe6255cb9e1': `إعادة تعيين الاختصار`,
's4730c232e7209c40': `تقليم كل من`,
's474f0eec369d02a4': `عينة من المخرجات`,
's47a8f6dfb38b9701': `التيلجو`,
's47e257ae643b5851': `وضع علامة على التحديد كتعليق توضيحي للتاريخ/الوقت`,
's47ebf3a8fb3b10c1': `التوجيه`,
's4802bb8eb52fbdeb': `البوابة`,
's4802e47fe2e95134': `الخيار`,
's491d2919cd6ec3d9': `هوى`,
's497838412cb455f2': `ظل النص`,
's4993444bfd3f3e5e': `انهيار`,
's49ad24935b14e3df': `الكيتشوا`,
's49c560aecfeb8c29': `القناع`,
's49dd67aed00029ef': `الرياضيات`,
's49e763aed00877a8': `الرئيسية`,
's4a894f57eba1cf1e': `اختصار لوحة المفاتيح`,
's4ac1ad6ecd6bd810': `متفرقات.`,
's4ad6e9d3c2365c98': `ضوء قوي`,
's4b2c143acf931122': `ارتفاع الخط`,
's4b58c01e2578f5e4': `الأسطورة`,
's4bbff4e008690da1': `تجنب الصفحة`,
's4c402ff5355fd310': `تجاوز ثنائي الاتجاه`,
's4caed5b7a7e5d89b': `اللغة الإنجليزية`,
's4cb38675a21b2c98': `نوع الخاصية غير المدعوم "\${desc.type}" (تتم المعالجة كـ JSON)`,
's4cc8391f172c0cdf': `إنهاء الجولة`,
's4ce8cc041a628847': `عند تغيير لغة المستند، قم بتحديث جميع لغات الأدوات وفقًا لذلك.`,
's4d528b416ac8dee2': `إدراج مجموعة عناوين`,
's4d546f6c87128d5b': `الفضاء أولاً`,
's4dcb9315f6527f9c': `التشغيل عند إعادة التحميل`,
's4e191bdb4700a6e9': `التمرير الزائد (x)`,
's4e1c7fdb470386ac': `التمرير الزائد (ذ)`,
's4e2562fe3990e621': `خطأ في الاتصال`,
's4e361bf8eef3759a': `استراحة الكلمات`,
's4ea0f21fc2a338a1': `تحرك للأعلى`,
's4eace13b3ed74187': `تعليق جانبي`,
's4efee5b48a4593cb': `الحلقة`,
's4f26e7cb7c0a8318': `الرسم المتجه`,
's4fd2e638aabb0bb3': `يدعم WebWriter تضمين العديد من المصادر المختلفة. ما عليك سوى لصق رابط لمحتوى من:`,
's4fda04cbc245e18b': `ألفا`,
's4ffac3fb33a2ee9b': `التايلاندية`,
's5015a8fb33b98872': `رقيقة`,
's50489ffb1bde152e': `الإدراج`,
's5068560b8d39663d': `خريطة قابلة للنقر`,
's517acbf1f96324f9': `الوزن`,
's523eb9043213ff0d': `مائل`,
's52777d434baeed9b': `إدراج مؤشر تقدم`,
's52af5d7ac34c2163': `صف الطاولة`,
's52e0bdc3ee304436': `أدخل مقياس`,
's52fb1524cb25d7ab': `موضوع جديد`,
's531056f039febd39': `إدراج تحديد`,
's536695196d0b6dc3': `فايروز`,
's542fcefa0bbaed86': `افتح صندوق الأدوات أو أغلقه (فقط على الشاشات الضيقة، وإلا فإن صندوق الأدوات يكون مرئيًا دائمًا على الجانب).`,
's5432ad3c84273229': `الشكل`,
's543906d1db8b2283': `تحرير `,
's543c237e8c895ce8': `بيسلاما`,
's545ee1f373f249cf': `كمبودي`,
's54897f2764b0e4d0': `تثبيت حزمة الأدوات هذه`,
's54cbfaf2a8da7818': `الباشتو`,
's550839f3e4e205bb': `حدد الاختيار على أنه مهم للغاية`,
's55905c735052d295': `استراحة مواضيعية`,
's5590dbf7e425789d': `التسمية`,
's5623aa2f83b05c76': `التبتية`,
's564d1648b1ceee9f': `حتى الآن`,
's565cd5ffb0158c46': `تجنب المنطقة`,
's571a4f19e2f140c7': `عموم (س)`,
's571db319e2f4208a': `عموم (ذ)`,
's575e795c45e2d97e': `ارجع`,
's5787c6d5b3b5541a': `مسار المقطع`,
's579c69f419b6caef': `سلس`,
's587ac858dd80f6fa': `منخفضة`,
's58bec0ecd4f3ccd4': `صارم`,
's59404f5593c32fdc': `تقنين أحرف الخط`,
's5941292bb77281ab': `اللغة النرويجية بوكمال النرويجية`,
's599dcd2472c75c19': `الفقرة`,
's59b20e8af32606ed': `عفار`,
's5a1a0898baf20675': `قم بتمييز التحديد بتعليق توضيحي للبيانات`,
's5a356677b61a6b7e': `مولدافي`,
's5b474b5c0ac0c7c4': `مجموعة أعمدة الجدول`,
's5b517ac216f9ee62': `جانبية`,
's5b8cc9bb61ddce15': `إدراج فقرة`,
's5bba2ac2e53bd1fd': `قرغيز`,
's5be80ad6b8301710': `البداية المضمنة`,
's5c1ecf88259b79f9': `العرض التقديمي`,
's5c2a1a52c0389c30': `الهندسة`,
's5c63af7695445fcf': `نمط النص`,
's5d18ca4c3111be6f': `إدراج رأس جدول`,
's5d87c1e588f48d90': `الممارسة`,
's5d929ff1619ac0c9': `بحث`,
's5da52af9b083c29a': `الطراز`,
's5dc77784260a7236': `السيارات`,
's5e27738a2e8eb763': `تسجيل الدخول`,
's5e2cba97c0d971bd': `حزم إعادة التحميل`,
's5e53415a6d5719ad': `العلوم الاجتماعية`,
's5e6a7a0c30d2a270': `تخطي التداخلات (تلقائي)`,
's5e9e8e4d21bafedc': `إنتاج الغذاء`,
's5ed03bb1f3a15949': `صورة`,
's5f43af3669b1e098': `المصدر`,
's5feaf7fd7ee567c8': `كلمة فاصل`,
's600fd23c9ce971e8': `طباعة المستند النشط`,
's602bbd28dae2c60f': `بدء التشغيل الذاتي`,
's60ff598dfcf2c773': `تحت اليمين`,
's61053f0e3ebbd272': `عادي`,
's613c6ff83883c04f': `عمود الجدول`,
's6196153c4b0c1ea0': `التثبيت`,
's61c017f6d5c303af': `الفريزية`,
's61ded17ca3f48c82': `إزاحة التسطير`,
's61eacb19db252f5e': `عنوان URL`,
's621ad19d35ba7742': `اختيار النسخ`,
's624e31cd4f1b89d4': `تمرير سلس`,
's626daf42b1ab7df7': `محاذاة اليسار`,
's6280bf993915c57a': `هامش التمرير`,
's62b857f5b6693742': `إينوبياك`,
's63d894b1ddb06289': `الوصف`,
's63dfc5b1c1c27849': `اليديشية`,
's63e03c70f67ebf9c': `السياق`,
's63e71d20d1eaca93': `الألمانية`,
's640bc7710d0143ce': `إعادة آخر تغيير تم التراجع عنه في المستند النشط`,
's64dc1fc7e3db45c9': `إنشاء مستند جديد`,
's65ac276544ba33cd': `ملف SVG`,
's66765c420ee578e4': `الفضاء بالتساوي`,
's669b18c6d2d9c95b': `لا يوجد`,
's6747dbf4ad6063ba': `النهاية الذاتية`,
's6787497df07fa97e': `قد يتم التمرير فوق نقاط التوقف`,
's67c2b60a506a09e4': `التعليم الثانوي.`,
's680bd4d926cd5a84': `الحفاظ على 3D`,
's6827930ef1aeaf99': `عنوان URL الأساسي`,
's684a16f3c711394d': `على اليمين`,
's687e27f036a71b32': `العزل`,
's68b87d7b61052dc3': `صف الجدول`,
's68e0e3a2bab7ce3e': `تجنب`,
's690da6b432987c6f': `تغييرات النسخ الاحتياطي للمستند الحالي تلقائياً. تتم استعادة التغييرات عند إعادة تحميل WebWriter.`,
's69311c4e25074fb3': `المدرسة الثانوية`,
's697400b541fbc3cd': `تحت`,
's6988ab5d47593a26': `لديك أحدث إصدار من WebWriter.`,
's69a49786a8009f43': `ابحث عن الحزم...`,
's69b12144dbb6544d': `لاوثيان`,
's69d88ef4b2618980': `الغلاف`,
's69fbbdb8ad2a084a': `سواد`,
's6a31eff1ec4f71ad': `إخفاء الوجه الخلفي (3D)`,
's6ac62e1c8c66f3bb': `مدمجة فائقة مدمجة.`,
's6b585ba37cdb8260': `التوريث`,
's6b61f8abf89586be': `العبرية`,
's6bd7a02fdf93e653': `محاذاة المحتوى`,
's6cfc66b824ea05ba': `حواف هشّة`,
's6d02dc19e21eb49c': `أعلى`,
's6d1df519e235a6cf': `توي`,
's6d60d595cb5070da': `الفيتنامية`,
's6d8b3b8047ed378d': `وضع مزج المزيج`,
's6d8c02aee480af7a': `قائمة الطعام`,
's6dadeaaee49d6d18': `ميتا`,
's6dfb502188a8c7c2': `إدراج نمط`,
's6e288a119281f4c2': `عرض النص`,
's6e4c20c6debcd5ca': `تبرير مخصص`,
's6f84199e62584905': `نص منسق مسبقاً`,
's6fb3053e7244d326': `مجالات أخرى`,
's70178e04a3b691b6': `فتح الإعدادات`,
's7031ca562378bde6': `دقة هندسية`,
's7060970b5ed20a58': `التفاعلية`,
's7136449045eff28c': `التاميل`,
's71940c32987f675f': `سحابة WebWriter السحابية`,
's71a0549fd71219c9': `إظهار الحزم غير المستقرة`,
's71dec51005acc1e4': `صف كثيف`,
's72f2a02e2a5a4ee3': `وسائل الإعلام`,
's730182ad28374cda': `الكائن`,
's731678e227a20559': `هذا الجهاز`,
's736904f276fbd441': `العلوم الطبيعية`,
's739544d0c858c633': str`أو أسقط 
          ${0} هنا
        `,
's73cb20c838e761e1': `اختيار القطع`,
's7417792bbe720149': `الإعادة`,
's741fae02b3dd24f3': `بكسلات`,
's743f778233e42a3f': `إدراج جانباً`,
's744d993d03f29851': `الشاشة`,
's74540c1b595a229c': `صيغة TeX`,
's748c0074eff45884': `التلاعب`,
's74aa0039a87141e2': `الحذف`,
's74b9781bacfcc87c': `البنجابية`,
's74cd20a7aece9b91': `صندوق التعبئة`,
's75109f5307578a61': `مرحبًا بك في WebWriter`,
's75a27f43413e02c5': `الفرنسية`,
's75d83fc3f0cfab40': `الرأس`,
's762e5704cc84089d': `تعيين خيارات الأنماط الأخرى للعناصر المحددة`,
's77318393dfdb0775': `إزالة الصف`,
's77e594ddcc10c774': `السماح بالاستخدام التجاري؟`,
's780099588362f80f': `عنصر التعريف`,
's782eac2b3e80323d': `ضع علامة على التحديد كما تم التأكيد عليه`,
's782f286a79cca35d': `النسبية`,
's78673a3539cb1915': `أعلى اليسار`,
's78789724e789221c': `الحجم`,
's789ff24c8f03f1a4': `تباعد الحروف`,
's7995733bf97c01cc': `الصربية الكرواتية`,
's7a99528e7b64635a': `أوكسيتان`,
's7aaf0c06e69600f1': `خطأ مع `,
's7ae49e142487766c': `الوصول إلى المجتمع`,
's7af555180b30a947': `افتح أدوات المطور`,
's7b4ba250601b8667': `إدراج قالب`,
's7b560d8693ed8f42': `مستقيم`,
's7b9994904c4f5b54': `الطاجيكية`,
's7bdf0fd5b014d36c': `أهمية قوية`,
's7beb1e77e82363eb': `التراجع عن آخر تغيير في المستند النشط`,
's7c61118554a0ec36': `الحد الأقصى (س)`,
's7c95876637f6a9d7': `التصفية`,
's7cb4e55c59663b1c': `الشركة`,
's7cfe12cd14df9950': `تسجيل الخروج`,
's7d27db3c9639c6dd': `بديل`,
's7d8103f6f06f83d6': `الحشو`,
's7d864465dddbb50d': `السماح بتغيير الحجم`,
's7de0e28d6c309a4e': `السماح بإجراءات اللمس`,
's7dea785045c3cc74': `اضغط على مجموعة مفاتيح جديدة...`,
's7e0b179d4d1414eb': `أدخل الرابط`,
's7e6570f2f1ae320f': `تركيب المحارف`,
's7ecb1f29332293e5': `خط الأساس للمحاذاة`,
's7ed13ccddb1bf3c3': `تراكب`,
's7edbe0b213199995': `البكالوريوس`,
's7ede1c55e35ce9d6': `المحاكاة`,
's7f09197a4814079b': `تعيين خيارات التفاعل للعناصر المحددة`,
's7f326a142e856656': `الطراز`,
's7fcb35d23be1e643': `مجموعة الحقل`,
's80570196a9ce6d11': `تمكين القياس عن بُعد`,
's806f84eb0ace116e': `شاهد ما قمت بتحديده وقم بتغييره. نسخ، أو قص، أو لصق، أو تثبيت، أو إجراء تغييرات في التخطيط. يقدم خيارات مختلفة بناءً على اختيارك، مثل تنسيق النص.`,
's80a42b81c52d4d8f': `لون علامة الإقحام`,
's80b71fc6f43c5ce1': `فضفاض`,
's812cbda653daaeba': `لم يتم تنفيذ هذه الميزة بعد`,
's81c3d8809658b951': `كشميري`,
's81cf65c5a46dea08': `كينيارواندا`,
's81ecf2d4386b8e84': `تابع`,
's8247d32213e35f24': `إدراج رئيسي`,
's82665b2ffabc9c0a': `الموقع الإلكتروني`,
's828b1ecea8715884': `مقلاة (يسار)`,
's833bd0422a7ef95d': `حجم علامة التبويب`,
's83420ad7b6a14db5': `تبديل أدوات التطوير`,
's83c15613b6f6f3c8': `عبر الإنترنت فقط`,
's83cd32b685ccc9b7': `عناصر التحكم`,
's83f26d02dd7aa681': `مرئي`,
's840fa49e8989c028': `الموضع/الشكل`,
's844a76d1843ceb3c': `إعادة التعيين إلى الوضع الافتراضي`,
's84e4e8ae645b82ac': `أعلى اليمين (ذ)`,
's84e9c7f8785ca60b': `إدراج نموذج`,
's8517ae4da104b004': `مجموعة أعمدة الجدول`,
's85186a61e0d55bac': `فيديو`,
's851a7deea5984646': `الترخيص كـ Creative Commons OER؟`,
's85f9aa6d3ea0e421': `مجموعة تذييل الجدول`,
's864b0e6270e97246': `ضع علامة على التحديد كتعليق جانبي`,
's8670e5ad3bf0dcf8': `حفظ باسم`,
's8688d74dd3716d6e': `اختصارات لوحة المفاتيح للأوامر`,
's86ca34c5287a2f38': `وولوف`,
's86f820d8007d0de4': `هامش الشكل`,
's87cefc710b3567fb': `احتواء`,
's88676f992b2965db': `محتوى خلايا التمدد`,
's886897f2fd4edb99': `مخفي`,
's886c5db2a5579873': `المفهوم`,
's888c71e8fcb916d3': `الحفظ التلقائي`,
's88a62d29529948fb': `إدراج جدول`,
's89950d86c8004d4b': `تخطي عدم التداخل`,
's89bca7498f20e041': `مقطع الخلفية`,
's8a28bad9290d4761': `أورومو`,
's8a29cb39a42f83f3': `استراحة قبل`,
's8a4ff2bd9c13498c': `السجل`,
's8a6585c48ea104e9': `إخفاء الخلايا الفارغة`,
's8a9eb438abac7c6a': `الملصقات`,
's8b0432eecbd8b034': `تحديث`,
's8b7580c35e2aef87': `أعلى اليسار (ذ)`,
's8bc4affa761aa8a2': `إدراج صورة`,
's8c7f51cb067644c7': `قائمة البيانات`,
's8d342ecaa9e75b9b': `العلاقة`,
's8d797888455f4147': `أماكن الاستراحة`,
's8d83386457e91813': `التراجع/إعادة التغييرات أو المعاينة من منظور المتعلم.`,
's8d8643013a7754d1': `محاذاة النص`,
's8df30fe2a50d3479': `إدراج فرصة فاصل أسطر`,
's8e715248c3a78446': `قطع التحديد`,
's8f29e48d6b9a1aa8': `إدراج صف رأس الجدول`,
's8f4be9f086eb530f': `التراجع`,
's8f533296a536965e': `حفظ كـ...`,
's8fad58c831ecf017': `حاوية نص روبي`,
's8ffe7abcbed8eb43': `عمودي، من اليسار إلى اليمين`,
's90105521fcc40453': `تتيح لك حسابات WebWriter Cloud تخزين المستندات عبر الإنترنت ومشاركتها مع طلابك. أضف حساباً هنا وسيكون متاحاً كموقع لحفظ المستندات وتحميلها ومشاركتها وفتحها.`,
's9095f01a80a91594': `سوبر`,
's90f0fbc12e1e2b2f': `لوحة الخطوط`,
's90f7c1cf501ea0a7': `مراوغة الألوان`,
's91093e0b087911ba': `موضع التركيز`,
's919e1724f589c9b1': `الفتحة`,
's91c5ed7769d00b65': `إدراج التضمين`,
's9219acd5bef6269e': `تحت اليسار`,
's92548405912d46bf': `محاذاة التمرير المفاجئ (ذ)`,
's9258280591309342': `محاذاة التمرير المفاجئ (x)`,
's927d796559f49439': `أصل الخلفية`,
's92b177e579ef7b97': `التوكيد`,
's92f846b9be2e8e8d': `ضع علامة على التحديد بخط مائل`,
's93566b84230af4f5': `إدراج صورة`,
's936aa0b239679585': `إدراج فاصل موضوعي (يُعرض عادةً كخط أفقي)`,
's9370dc6afa716b57': `الحدود`,
's93f083e654a45715': `بريتون`,
's94653c76b2d86a04': `المصطلح المحدد`,
's9485af2e7cd9418f': `مدرسة ابتدائية`,
's94d2eee44b292567': `تبديل الخيارات المتقدمة`,
's94d61907ee22a8c1': `كوري`,
's94eb1effbbb6498b': `الفائض`,
's951aa3a6439f1271': `علامة القائمة`,
's9565553d163fc92a': `السيناريو`,
's957787fc6b7ea5c0': `مقلاة (لأعلى)`,
's95d56e58f816d211': `اللغة الهولندية`,
's95d8e41a64635c7c': `مساحة بيضاء`,
's95de7e1eff6c053e': `أفقي، من أعلى إلى أسفل`,
's960d3a90ac199368': `الرايتو-روماني`,
's96532132a29dd542': `إدراج الصوت`,
's96a045dcade75ad0': `كثافة العمود`,
's9781a5bb3fcb26a3': `اختر شركة أولاً`,
's978522fbc9577a7e': `الصومالية`,
's97881699a2b21d5b': `فجوة الصفوف`,
's97aa76056a81bd36': `المقاييس`,
's986facb3ecc9602c': `جانبياً، من اليمين إلى اليسار`,
's987abd19fac8cf55': `الفرعية`,
's9896529e5cb20558': `ملف خارجي`,
's98977a87d1b93941': `إعادة تعيين المعلومات والأنماط والنصوص البرمجية`,
's98b1cb8fb62909ec': `المجموعة`,
's990d0e0fa2ab00b5': `الجاليكية`,
's99229574e5692f19': `غرينلاند`,
's99a990f3841ad283': `ملفات `,
's99b38e000175cc84': `يتوسطه خط`,
's99f110d27e30b289': `العنوان`,
's9ab10fbf4c7a7322': `موضع التسطير`,
's9abadcc828884d7b': `مساحة النص`,
's9b7cd8860c8fc922': str`
          ${0} سيتم الكتابة فوقها. هل أنت متأكد؟
        `,
's9c11f2d9335d8bd1': `أوريا`,
's9c356016f81585f6': `لون الخلفية`,
's9ca757effd747da9': `الأردية`,
's9caf10388ab3562f': `عمود الجدول`,
's9cf68f87b8e6122f': `أذربيجان`,
's9d167ef77aed79b6': `الطبقة`,
's9d2d00982edafabb': `اللغة التركية`,
's9d430adc5be110e9': `صف عكسي`,
's9d54829be67943d3': `إنترلينجيو`,
's9d54869be6794a9f': `إنترلينجوا`,
's9d668a34af4128ff': `الحذف`,
's9df571714a1efb44': `تتوفر نسخة محفوظة تلقائيًا من هذا المستكشف. تحميله؟`,
's9e28faa598332e2b': `إدراج الفيديو`,
's9e3dbb678150edd4': `تعيين عائلة الخط`,
's9e40e59654c8ad67': `العمود`,
's9e85800d3700e31c': `المضمار`,
's9e8d3665edde89a6': `ناورو`,
's9eefe6e57e4e1661': `متغير الخط`,
's9f1ecdb3061d9cbc': `الحفاظ على المساحات`,
's9faf26107ed49fb9': `إدراج خلية جدول`,
's9fbe26cfd7845469': `الهوسا`,
's9fc686f7bbd941e2': `المرحلة الانتقالية`,
's9ff3121d30f88d52': `عادي`,
's9ffe1bbe64712bf1': `اللوحة القماشية`,
'sa00df4e39c72d3b4': str`
          ${0} غير مدعوم
        `,
'sa013e119fec906fb': `الصف`,
'sa01e7bf33563ef72': `مرفق الخلفية`,
'sa126cf8c627cec1e': `عرض الصورة`,
'sa13f72278add7513': `تحت اليمين`,
'sa1647e3b36ec08d7': `اجمع بين العمودي`,
'sa172190ea21f9b1c': `ادخل إلى الإعدادات، وافتح مستكشف أو أنشئ مستكشف جديد.`,
'sa1c6c459b9b5115c': `مطلق`,
'sa2cba871f6cdd99f': `آسامية`,
'sa2eff4dad1c119f1': `قالب الشبكة`,
'sa30c12014e955946': `الروسية`,
'sa30f1981fd1cd441': `حجم الخط`,
'sa311a24c1471a974': `المستند`,
'sa352d168b262aa06': `إدراج تذييل`,
'sa37fee6a52d18063': `حذف المستند`,
'sa39c7ac1d37f3bce': `وضع علامة على التحديد على أنه "عزل ثنائي الاتجاه`,
'sa3b4c01623211544': `القوة`,
'sa40fd43756fa8913': `فارسي`,
'sa417644bef21a9aa': `موضوع غير مسمى`,
'sa43800e28be1bdbc': `لون الزخرفة`,
'sa477cb1825dceb3b': `سوداني`,
'sa492a51a707930fa': `إدراج اقتباس مجمّع`,
'sa4e5b39489ecf31a': `الزوسا`,
'sa4f137f8619093a5': `التسمية التوضيحية في الأسفل`,
'sa50d3c35533f1d99': `جميع المجالات`,
'sa53c5cb03a8fda50': `ثبِّت التحديد كمقتطف في اللوحة`,
'sa557ae6bee9148a6': `التقدم المحرز`,
'sa589e1df65dde0ec': `تعيين الحجم، والحشو، والهوامش للعناصر المحددة`,
'sa5c371b4bb75e590': `يسار`,
'sa5c80e623459ffe4': `إدراج رأس`,
'sa5df1bcdba46c3fb': `التسمية التوضيحية للشكل`,
'sa602e3fd3f2d98fd': `الرسوم المتحركة`,
'sa644d580d8a11e60': `محاذاة روبي`,
'sa645d315510dc09e': `اختر المسار من القرص`,
'sa65d4ad99f1d8c06': `تعيين خلفية النص`,
'sa6607436f60ccc1a': `الإستونية`,
'sa6f8d27bca557059': `نقل عناصر التعريف/الرابط/الأسلوب لأعلى/لأسفل إلى هذا العنصر`,
'sa757645ad842da97': `الحفاظ على الفواصل`,
'sa75b95980cd80e78': `محرر`,
'sa7698b3d20a6d1ec': `التمرير`,
'sa778acc33947c7b8': `إنهاء الجولة`,
'sa78a67272a4a6f95': `معادلة الرياضيات`,
'sa79167651dce1e80': `نص بديل`,
'sa7af797a46c7d09a': `تذييل الجدول`,
'sa7dbe35b758c138d': `إدراج لوحة قماشية`,
'sa7dc6b8ef3f595dc': `إدراج مصدر`,
'sa8279f8211b3950d': `الحفاظ على الفواصل والمساحات`,
'sa8b55cab62e439b5': `إزالة العمود`,
'sa8bbe0197d31b423': `وصف موجز`,
'sa9ff3b762365abe6': `أصل التحويل (z)`,
'saa02e3762368ff35': `أصل التحويل (ص)`,
'saa065776236bfa28': `تحويل أصل التحويل (س)`,
'saa33768e03c45fc8': `حجم الملف`,
'saaad98061a20ac39': `إدراج صيغة رياضية`,
'saab875d8cfcfe712': `الموضوع`,
'saad4380b9cc6cefd': `تناوب على`,
'saaec15c97a9e4245': `عكس العمود`,
'sab0c57df694a0a09': `بدء التشذيب`,
'sab4d9283896d9422': `بكسلات دقة الالتقاط`,
'sab55faae8e165407': `الحشو&lt;br&gt; مثل الفجوة`,
'sab5e7d2a069a2951': `شهادة مهنية.`,
'sab726d2db7e6b93d': `كيروندي`,
'sac687b8649989de8': `محاذاة اليمين`,
'sac895c732f350ac5': `داكن`,
'saced41ddda8b2354': `أساس مرن`,
'sad190f86451081c0': `النيبالية`,
'sad6be321164d08c8': `الرياضيات المدمجة`,
'sadd352cc7f6f2307': `إلى جانب ذلك`,
'sae098810f946ca7c': `التاغالوغية`,
'sae185e6af80ec81e': `اللغة السويدية`,
'sae1c7f13b7c0c47f': `ابدأ`,
'sae76e25497dcee58': `ريكتو`,
'sae9c790b88be7eb9': `الماوري`,
'sae9d739068eee2c5': `تتار`,
'saf312eaeec77a802': `إدراج قائمة وصف (مسرد المصطلحات، قائمة المصطلحات)`,
'saf3da7c95cb17260': `قم بتمييز التحديد كحرف فوقي`,
'saf440a0a592f2835': `تحديث إلى`,
'saf9e5134ba1a7d30': `التمرير السريع`,
'safc6f203342d09e2': `تبديل المعاينة للمستند النشط`,
'sb0a7e3adf4a125ee': `أعلى اليمين`,
'sb0a974028c99ca6d': `السماح بالتكيفات؟`,
'sb0d4f0f7993cf085': `تعيين حجم الخط`,
'sb0f3327210fe18fc': `الأعمدة`,
'sb0f93c1c60c0249a': `قاعدة روبي`,
'sb1494c08c8c720d1': `تعيين لون النص`,
'sb19611adbc88f711': `متقدم: إظهار أوامر تحرير المصدر، على سبيل المثال لإظهار HTML الخاص بالمستند أو لإضافة أنماط ونصوص برمجية مخصصة.`,
'sb206d700d26b14ff': `تسطير`,
'sb233557012dcb328': `تحرك لأسفل`,
'sb26035b596566abf': `لم يذكر اسمه`,
'sb2cda80610c8d6ea': `مساحة الكل`,
'sb2dc787b0983ebc6': `الليتوانية`,
'sb31cdff08b1c5a50': `السندية`,
'sb38d497d992ab4a4': `المركز`,
'sb3ba3276ae93627c': `إدراج كتلة نصية منسقة مسبقاً`,
'sb430f5b4824de0d3': `اختر تخطيطاً`,
'sb43db07b24da018a': `الأمهرية`,
'sb45f9fb4dba6e71a': `إلغاء التعيين`,
'sb4e003a459464d85': `الكردية`,
'sb4f0310e6787d098': `الأوزبكية`,
'sb4f1dffbb6be6302': `واضح`,
'sb51270e19988f9bd': `المنطقة`,
'sb59d621e3c93cc27': `حدود الخلية المشتركة`,
'sb5e9e1776242b028': `التفاعلات`,
'sb60bc1250aad44c1': `الامتداد`,
'sb60dd9d23d31ee66': `دكتوراه`,
'sb6103872073d369e': `أدخل التفاصيل`,
'sb616811735bfbafd': `خلية الجدول`,
'sb628960829e223bb': `تخطي كل التداخلات`,
'sb6434faf698b02a2': `شونا`,
'sb657bfe93338dc8b': `فولابوك`,
'sb66beca1e766dcb3': `التقديم والاستيراد`,
'sb66e2181a7b5738a': `من خلال تمكين القياس عن بُعد، فإنك تسمح بجمع البيانات والاحتفاظ بها وفقًا لـ`,
'sb67e0e7c0869f982': `الفرق`,
'sb68e83cda6c85af8': `رأس الجدول`,
'sb6b268120592dc53': `هندي`,
'sb6ca0a8bb3caae69': `سُمك الزخرفة`,
'sb70c17f7899f9b01': `اللاتينية`,
'sb71941f552f3504d': `تعيين قيمة خاصة`,
'sb740eab4afd5a710': `التدفق التلقائي للشبكة`,
'sb741b6e0ca589122': `الطبقة العكسية`,
'sb7c77d0415de05cf': `إجراء الاختبارات`,
'sb7fb7568f6883ab8': `مشاركة المستند النشط`,
'sb85774dc5d18ff0f': `تأكيد`,
'sb85b1e36579852a6': `البريد الإلكتروني أو كلمة المرور غير صالحة`,
'sb884fa76bfc55429': `اللغة العربية`,
'sb8a3d4df7d1c5e6b': `الرصيد`,
'sb8f610a0e8df91fc': `اللمعان`,
'sb8f855b49234b81b': `قدم طلبك`,
'sb905da066c10182c': `زائد أغمق`,
'sb940ade1bd81be7e': `تحت اليسار`,
'sb9e9a7dd45966756': `ضع علامة على التحديد بالخط العريض`,
'sba509fd8ed61d1d5': `ملف غير محفوظ`,
'sba64d8954d027206': `التعتيم`,
'sba88d90cd6c751b3': `قاعدة العمود`,
'sbaf0a7c417e388af': `الصحة`,
'sbb15d427ee1aa676': `التيغرينية`,
'sbb34f2e3aa40af4e': `تونغا`,
'sbb55f9f2d69fd327': `مرشح الخلفية`,
'sbb85a407d730e13d': `إدراج بحث`,
'sbb86c6c96f598bb8': `مختلط`,
'sbba0156f795d8c07': `تحرير التحديد`,
'sbba865d4b437944f': `السمة`,
'sbbe639e3a3ed95d1': `نوسكربت`,
'sbc5bb5bb74d141b9': `إلغاء التثبيت`,
'sbc5f2a81604baf9b': `العنوان 6`,
'sbc5f2b81604bb14e': `العنوان 5`,
'sbc5f2c81604bb301': `العنوان 4`,
'sbc5f2d81604bb4b4': `العنوان 3`,
'sbc5f2e81604bb667': `العنوان 2`,
'sbc6953a36ced943f': `سياسة الخصوصية`,
'sbd181cd54b8402a4': `تحرير التحديد`,
'sbd35ee879d9cf770': `نص روبي`,
'sbd40f40cbadd38d5': `إزالة حزمة الأدوات هذه`,
'sbd72dc858de95ce8': `البورمية`,
'sbe3c60c65f129daa': `العلوم الإنسانية`,
'sbe4a7c8f231739b3': `أو لصق/إسقاط/اختيار ملف`,
'sbe90de083557ef3e': `السواحيلية`,
'sbefb6064cba01844': `إدراج فاصل أسطر`,
'sbf00e1ee999ea94e': `إدراج نص برمجي`,
'sbf519920c2017d67': `تعليق`,
'sbfa01f189a68d3e9': `نمو مرن`,
'sbff54e740c4086eb': `إظهار حزم غير معروفة`,
'sbfff51feacf30196': `السنسكريتية`,
'sc0ceaa9843510f67': `التركمان`,
'sc1611c0558728a2a': `المنصب`,
'sc1a155cc25899250': `مجموعة صفوف الجدول`,
'sc1aa1f6051b7102a': `الرومانية`,
'sc1edebeaef92b7bd': `تخطيط الجدول الثابت`,
'sc1fff4f356dfb2fb': `التحويل`,
'sc221faca1ecb4aee': `مجهول`,
'sc24bda3c061fddf8': `منطقة قابلة للنقر`,
'sc252a4e091763606': `إدراج تذييل جدول`,
'sc2536e077514accc': `التمرير`,
'sc275dd00036d16cb': `اقتباسات شخصية`,
'sc28864200d2a3799': `نسخ رمز الاستجابة السريعة كصورة`,
'sc2a24a9dd41a9503': `خط الزخرفة`,
'sc2b734cca2fa643b': `مقلاة (لأسفل)`,
'sc2e2a0dbf03723b7': `متقدم: إظهار الحزم من مصادر غير معروفة في مدير الحزم (تحذير: قد تكون غير آمنة)`,
'sc3998b77d72c2932': `إدراج موقع ويب (كإطار مضمن)`,
'sc3ac225273c8316b': `جنرال لواء`,
'sc3cfee84dbbf36ae': `الملف المحلي`,
'sc3f09a9b6fa4fbed': `في الداخل`,
'sc43767deea72e9f3': `قائمة الوصف`,
'sc462bbdd36bcba6b': `المربع المرجعي`,
'sc4ee3e4ee994dafd': `أوكراني`,
'sc50d09edf9325339': `حوار`,
'sc52b67794c06a0d3': `أصل المنظور (ذ)`,
'sc52e8b794c0913d6': `أصل المنظور (س)`,
'sc53de149fcaad713': `بين الشخصيات`,
'sc546f489f9c0cced': `تبديل وضع الاختبار للمستند النشط`,
'sc5bcf50d1b578d9f': `إعدادات ميزة الخط`,
'sc5cb39478b9b7625': `وضع علامة على التحديد كخط فرعي`,
'sc6415b50ff928294': `قائمة البنود`,
'sc650ff15b20fe9d3': `تدوير (z)`,
'sc6578b15b2154365': `تدوير (س)`,
'sc65aff15b2183e58': `تدوير (ذ)`,
'sc6da0f4a7e4d710e': `تجاوز لغة الخط`,
'sc74e3567875ce255': `كل من علامة الأداة واسم حزمة NPM الخاصة بك`,
'sc7eb080b96e244df': `الملايو`,
'sc8ac7ef92b95df3f': `نقل (س)`,
'sc8af536e2084ade0': `لوحة الألوان`,
'sc8b022f92b992bc2': `نقل (ذ)`,
'sc8b39af92b9c2d81': `نقل (ض)`,
'sc8d2c7f6c33a2b32': `تعيين نمط النص (المحاذاة، والمسافة البادئة، والتباعد، وما إلى ذلك) للعناصر المحددة`,
'sc8fa0e3de389ef1c': `ضبط حجم الخط`,
'sc9474bf7a0668d73': `الملخص`,
'sc94e314312a8900c': `التشيكية`,
'sc980855a000b76ea': `القاع`,
'sc98b103772de63f4': `الفنلندية`,
'sca7cfe2bef51b2a5': `الجذر`,
'sca7fed2bef53cb99': `الدور`,
'scabe6ecee5e01fd2': `المالطية`,
'scace301a88231cce': `تضمين`,
'scbc55f622ec078c1': `عرض المربع`,
'scbe537fc38ff4c13': `أعمدة الشبكة التلقائية`,
'scc1db59d292cbc4c': `القسم`,
'scc56b218a2689c42': `الأرمينية`,
'scc5ba32e0de06744': `سيسوتو`,
'scd15088c39fe9edf': `صندوق الحشو`,
'scd9cedeb5ece3adb': `الوصل`,
'scdf536b65be39ec5': ` إنشاء/استيراد`,
'sce8a4e3f7c98482d': `سيسواتي`,
'scec2be75ee985f6c': `إيديوجرافيك`,
'sceecdd0bb404bc17': `إدراج مجموعة خيارات`,
'scf00d48fd5953a03': `اليونانية`,
'scf932840a69dbb7c': `البرتغالية`,
'scf932a8577057752': `التذييل`,
'scf95dcb12a950a5c': `أيمارا`,
'scfcb70f2a15eaf14': `أسفل اليمين`,
'sd01178c54f648118': `أعمدة الرصيد`,
'sd03bff50f87f82d4': `حرف الواصلة`,
'sd05a155fe09c2866': `عبر الإنترنت عند استخدام`,
'sd0864ea6cb6ef22e': `المجتمع`,
'sd10fdbe6caf9a998': `فاصل السطر`,
'sd121d3b959b7888d': `تحسين السرعة`,
'sd1a78e667a1a139f': `وضع علامة على التحديد كإدراج`,
'sd1cffad290ea5b3b': `احتفظ بالجميع`,
'sd1f10284eeb17b25': `فيجي`,
'sd1f44f1a8bc20e67': `البريد الإلكتروني`,
'sd1f81984eeb7c0e8': `تعبئة`,
'sd29dc07235eea0f5': `اقتباس`,
'sd2addf69477cd4b4': `حزمة الاستيراد`,
'sd2ed26defc646d47': `مرشح الخلفية`,
'sd2ef82b8ea877c6d': `الأفريكانية`,
'sd319aae1401f1e19': `ثابت`,
'sd3a288c1094b8a63': `عرض قاعدة العمود`,
'sd3c65ef5c380c046': `مدمج`,
'sd3dcb76f7b28adb8': `اللاتفية`,
'sd3eca1e0f4209f6e': `تقليم الكل`,
'sd3f402df8619ddcd': `تتم إضافة هذه المعلومات الخاصة بك تلقائيًا إلى المستندات الجديدة. يمكنك تغيير ذلك لكل مستند في محرر البيانات الوصفية.`,
'sd4368b12645d3c0f': `إدراج بوابة`,
'sd452cebf4a0313d1': `إظهار أوامر تحرير المصدر`,
'sd48cc52117f4d68b': `إيطالي`,
'sd52660ee947ca58b': `إدراج عمود جدول`,
'sd588d17a1b25c220': `تجاوز النص`,
'sd5be6f6d85fc0c9b': `زولو`,
'sd5bf67958b08b4cf': `التعليم العالي.`,
'sd5cf95145e4d89ca': `قم بإلغاء تثبيت هذا المقتطف`,
'sd5fd9d11a92f5b1d': `أسفل اليسار (ذ)`,
'sd60c9bbc51375635': `إدراج زر`,
'sd66c4767fa3dde28': `لون مميز`,
'sd679c8b1bf8cc8a5': `القبعات الصغيرة`,
'sd7086c4425c53c80': `عائلة الخط`,
'sd837f42ac7cbfb58': `الشكل (خارجي)`,
'sd88076d2994ee0fb': `الاستبعاد`,
'sd89a2e529b31ef43': `الرجوع`,
'sd8a345e95668b73b': `عمودي، من اليمين إلى اليسار`,
'sd8ce9e57270b030d': `امتداد الخط`,
'sd8ecf227c7c49331': `الرياضيات`,
'sd8f923198e0c5c6a': `النهاية`,
'sd9c21e5f60d6bdd8': `دنماركية`,
'sd9ff8e2612e63d50': `تحجيم مربع الحدود`,
'sda2d76b976502a8d': `افتح...`,
'sda344aacb837387e': `الموضع في الحاوية`,
'sda5b6fa8b771f996': `تعويم لليسار`,
'sda9254d1f1228e1a': `الهنغارية`,
'sdb1595f5c742dfbb': `المدخلات`,
'sdb711380a28fec75': `إدراج قائمة (مرتبة)`,
'sdb73788b3c975f16': `السيارات`,
'sdbee7e0523a23a42': `أسفل اليمين (ذ)`,
'sdc12d4d35420eeb7': `التعليقات`,
'sdc48456f9a27ae02': `المولدات`,
'sdc70d81cf6c28533': `جورجي`,
'sdd1ff479d04ac140': `عام`,
'sdd2fc8919a9c3111': `وضع مزج الخلفية`,
'sdd35b688281b6dea': `ياباني`,
'sddc49047f66a64ab': `لم يتم تقديم أي وصف`,
'sdef34fe08bb28b09': `الصينية (المبسطة)`,
'sdf62e305e1594805': `قم بتمييز التحديد بتعليق توضيحي ياقوتي`,
'sdf946172dfa0328f': `حرف فوقي`,
'sdf9bc5d9b7f3e3de': `المحاذاة`,
'se036b53f145441cd': `محتوى مختلط`,
'se06f459fccdc3ce9': `محاذاة سطر النص الأخير`,
'se0a782a8be8e018b': `النرويجية`,
'se0cda6b80a1bb50f': `السلوفاكية`,
'se0f67eae944f8f94': `كتم الصوت`,
'se1312d6528f9a259': `اليوروبا`,
'se16c5e66886fbc59': `المادة`,
'se1f5bb0386c88f96': `يضبط لون النص المحدد`,
'se219da7b1e955c65': `تنسيق واضح`,
'se25e4f2cb77b8be8': `لغة واجهة WebWriter والمستندات الجديدة`,
'se2796c5824ec8916': `رؤية المحتوى`,
'se308836a594808b6': `سنغالي`,
'se36c5b1baf5e0660': `أي مكان`,
'se39c065efa467782': `الباسك`,
'se3b4c857f91f80d7': `اختصارات لوحة المفاتيح`,
'se47baf2fd16b9d2b': `القالب`,
'se48bd9e6c2a3109d': `الحسابات`,
'se58467472725ad0c': `دقة الصورة`,
'se58f06c2b0583ff7': `اختر الإحداثيات`,
'se5dc1e97fb743ade': `التباعد`,
'se619a501d1bfe6a5': `التفاف`,
'se62385ac082368d2': `وضع علامة على التحديد كمصدر للاقتباس`,
'se6297163cac9d276': `تحرير المصدر`,
'se633223a0b88625e': `وضع الخلية`,
'se638417c560cfe5c': `استراحة بالداخل`,
'se64f418b4e733b6c': `إدراج مخرج`,
'se79c0a3ac70d8fb3': `النسبة (س)`,
'se79fae3ac710dc36': `النسبة المئوية (ذ)`,
'se7fad370d8fb4cec': `تحسين وضوح القراءة`,
'se8a94b4effa2033e': `حروف الهجاء`,
'se95d4e55ea186d9a': `لون شريط التمرير`,
'se96d43a515b8451c': `السلوفينية`,
'se96fd76ba1b2975a': `المركز`,
'se9ac05f36b004eb0': `إخفاء الجولة التمهيدية. تعطيل حتى تظهر الجولة مرة أخرى.`,
'se9b1fec72ffd8f48': `محلي`,
'sea24bdcaa2bd2dec': `الخاطف الإلزامي`,
'sea52df2b70a5c10d': `روبي`,
'sea6e7291e27ec53f': `تبديل محرر بيانات التعريف`,
'sea896ed51ad33287': `لا توجد أنماط محددة متاحة`,
'seaaaeb09e3b4e78b': `تحرير الأوامر`,
'seabae79729c4b2ad': `تبديل البريد الإلكتروني`,
'seaecc8267bad6234': `المدرسة الإعدادية`,
'seaf97719986faf4f': `الفجوة`,
'seb19675a580f0628': `تجنب العمود`,
'seb4e52ef5ec7a7dc': `الألوان/التأثيرات`,
'seb8982ae8c3cdcc5': `الإندونيسية`,
'sebbced89e0db2894': `خط الأساس الأول`,
'sec02109a0dd2a6c8': `لون التركيز على اللون`,
'sec2557a35b702525': `متغير`,
'sec2da4aa7a02b925': `الأيسلندية`,
'sec30fbb20f102670': `إدراج الملخص`,
'sec8b0b6c729816b6': `مجموعة العناوين`,
'seccd05955adb76bc': `ملصق`,
'sed17285cd25d6389': `الدليل حيث توجد الحزمة.json`,
'sed318ec045c5144f': `حول`,
'sed713f1b916fb469': `تباعد الحدود (س)`,
'sed74a31b9172942c': `تباعد الحدود (ذ)`,
'sed86bd0deb2e5372': `تحويل النص`,
'see2fcaedf9743ec6': `الموقع`,
'seec6798afe90ffc8': `طباعة`,
'sef00c258bc1ecf1e': `يحتوي هذا المستكشف على تغييرات غير محفوظة.`,
'sef23dd271edd4a8b': `أسفل اليسار`,
'sef24caccbd4645ef': `انكماش مرن`,
'sef49aec68fd1dc66': `الاسم`,
'sef73fe18e351eb35': `الكلمات المفتاحية`,
'sef75f458d77491af': `مجموعة الخيارات`,
'sefcf950b3cc4fc3b': `اللغة`,
'sf0c8e2b013e5ff18': `بوتاني`,
'sf0ca10f343249063': `المحتويات`,
'sf0cab2483f66aa2e': `مخصص`,
'sf0e261e04eda82ff': `المظهر`,
'sf1045382c1fd9a85': `ألوان الطباعة الدقيقة`,
'sf14c35392ec7bf10': `هذه الميزة غير متوفرة في Firefox. وهي متوفرة في Chrome أو Edge.`,
'sf14f9d5f9f6ca342': `بالإضافة إلى أخف وزناً`,
'sf1868dc19e3917bb': `الإسبانية`,
'sf190149f9d8bbb2a': `وضع الكتابة`,
'sf1e79171c4856543': `هل أنت متأكد؟ لا يمكن عكس هذا الإجراء، سيتم حذف جميع إعداداتك وإعادة تعيينها.`,
'sf21c1f60c7515f44': `وضع علامة على التحديد كعينة إخراج`,
'sf21fb4f4b9e8911f': `العرض`,
'sf22a3737146ec910': `يمكن ل WebWriter تضمين SVG مباشرة في المستند.`,
'sf2514d5dc78b1654': `إدراج عنصر واجهة مستخدم`,
'sf28903d4ca0ddcfc': `إزالة هذا الحساب`,
'sf2ab37af0abc55ef': `إخفاء جولة تعريفية`,
'sf2bdb0b4d7b9c039': `البنغالية`,
'sf2cbb5e519264e67': `تغيير الحجم أفقيًا وعموديًا على حد سواء`,
'sf2d5cbc2fe0ad65a': `لزجة`,
'sf2d96d0eb32cb81f': `تكوين الرسوم المتحركة`,
'sf2de3dbe2108637a': `عرض الشكل`,
'sf2e08a945e9194d4': `ويلش`,
'sf34696c526e810b4': `مضمنة`,
'sf39736a666dbb038': `إدراج مسار`,
'sf3c4da68b08a2590': `مدغشقر`,
'sf471ec2496f904cc': `تجاهل التغييرات`,
'sf4849bc200e279ed': `شرح الجدول`,
'sf486ca1fdbe08645': `إدراج شكل`,
'sf4b537d4cbd8f5fd': `أعلى النص`,
'sf4e0e02a5277ef23': `إدراج مساحة نصية`,
'sf4f067d41efd4b83': `المقياس (ذ)`,
'sf4f3cbd41f002b46': `المقياس (س)`,
'sf4fa67d41f05a008': `المقياس (ض)`,
'sf5197db2d5f2926a': `تدوير`,
'sf52d840949a980d1': str`
          ${0} سيتم حذفها نهائيًا. هل أنت متأكد؟
        `,
'sf55d634dcc743595': `الخدمات`,
'sf59c9081d106dd9c': `وضع علامة على التحديد كمتغير`,
'sf5e76f774beb33c2': `إينوكتيتوت`,
'sf64a8229a8136552': `حذف مستند`,
'sf65df67a03bebe4b': `مطلوب لهذه الأداة`,
'sf6673729c03ae999': `إعادة تعيين WebWriter`,
'sf67571992e7dc88e': `المدة الكاملة`,
'sf6b4934598f7ed10': `السماح بالاختيار`,
'sf6e1665c7022a1f8': `كلمة المرور`,
'sf79e0d78b56444f1': `نهاية مضمنة`,
'sf7a5f7a7c80c3082': `كلاهما`,
'sf7c0eba7c822e3d6': `جريئة`,
'sf86bd4d2982f3b74': `وضع علامة على التحديد كرمز`,
'sf8e82313fa411494': `وضع علامة على التحديد كرابط`,
'sf955eff73fb6b573': `الصربية`,
'sf9929e2d356260c5': `الضرب`,
'sf993bb199fefbe04': `الكل`,
'sf9ecf969dd4b8164': `كلا الحافتين`,
'sf9f2c719a04066ec': `التطبيق`,
'sfa49a5bb1a5d353e': `الوصول الخاص`,
'sfa59c7777e2a0eeb': `إدراج قائمة بيانات`,
'sfaa0a67db5c11f72': `وضع مسافة بادئة للسطر الأول من النص`,
'sfb231a52211b133f': `لا يوجد التفاف للنص`,
'sfb68cae41d749423': `مبدئي`,
'sfb9b6edb0ed378c9': `مصدر الاقتباس`,
'sfbbab09dbe553571': `إدراج رسم متجه (SVG)`,
'sfc00292e778b67e2': `العداد`,
'sfc63e31ac7c956ed': `اختر`,
'sfc815c9078bba30a': `تنزيل رمز الاستجابة السريعة كصورة`,
'sfcdd8e672c75b713': `العنوان`,
'sfcebd18506f1e535': `التدفق`,
'sfd0cde85070d2eb2': `فليكس`,
'sfd77270c3f54f664': `المخرجات`,
'sfdb1e4d90981a535': `شارك هذا المستند`,
'sfdeef3dccf409f81': `هذه الكلمة الأساسية مطلوبة للأدوات`,
'sfe6e758ad2603c1d': `الماجستير`,
'sfee1c12daf838935': `حرق اللون`,
'sff303daee4dd9f7b': `لينغالا`,
'sff3df0c2823ec6e4': `فيرسو`,
'sff99962304ac7d25': `إدراج مربع حوار`,
'sffa395f64ec6ac36': `البلغارية`,
'sffdadf0a576fd802': `الارتفاع`,
'spaceKey': `الفضاء`,
'tabKey': `⭾ علامة التبويب`,
'upKey': `↑ لأعلى`,
    };
  